import router from '@/views/routers'
import store from '@/core/store'
import {Alert, PageUtils} from '@/core/utils'
import ApiErrorValidations from '@/core/exceptions/ApiErrorValidations'
import {mensagens} from '@/core/constants'
import _ from 'lodash'

const alert = new Alert(store)
const pageUtils = new PageUtils(router)
const tempoEsperaRedirect = 6

class ExceptionHandler {
    execute(error) {
        if (error instanceof ApiErrorValidations) {
            this.tratarValidationError(error)
        } else {
            this.tratarError(error)
        }
    }

    tratarValidationError(error) {
        if (error.multipleErrors()) {
            this.handleMultipleErrors(error.response.data.errorMessages)
        } else if (error.disconnected()) {
            this.handleDisconnected()
        } else if (error.badRequest()) {
            this.handleBadRequest(error)
        } else if (error.unauthorized()) {
            this.handleUnauthorized()
        } else if (error.internalError()) {
            this.handleInternalError(error)
        } else if (error.notFound()) {
            this.handleNotFound(error)
        } else {
            this.handleUnknown()
        }
        throw error
    }

    tratarError(error) {
        alert.showError(error.message)
    }

    handleMultipleErrors(errors) {
        const errorMsg = errors.map(err => err.message).reduce((total, prox) => {
            return total + ' \n' + prox
        })
        alert.showError(errorMsg)
    }

    handleDisconnected() {
        alert.showError(mensagens.DISCONNECTED)
        pageUtils.goToHome()
    }
    
    handleBadRequest(error) {
        const ehDomainException = _.get(error, 'response.data.key') !== undefined
        const ehExceptionList = _.get(error, 'response.data.errorMessages.length') !== undefined
        if(ehDomainException) {
            tratarDomainException(error)
        }else if(ehExceptionList){
            tratarExceptionList(error)
        }else{
            alert.showError(mensagens.UNKNOWN)
        }
    }

    handleUnauthorized() {
        alert.showError(mensagens.LOST_SESSION)
        pageUtils.reload()
    }

    handleNotFound(error) {
        this.handleInternalError(error)
        pageUtils.goToHome()
    }

    async handleInternalError(error) {
        if (error.response && error.response.data instanceof Blob) {
            const errorText = await error.response.data.text()
            const errorJson = JSON.parse(errorText)
            alert.showError(errorJson.message)
        } else if (error.response.data.message) {
            const msgFormatted = error.response.data.message
            alert.showError(msgFormatted.toString())
        } else {
            this.handleUnknown()
        }
    }

    handleUnknown() {
        alert.showError(mensagens.UNKNOWN)
    }
}

function tratarDomainException(error){
    if(error.response.data.key === 'LICITACAO_DESPUBLICADA') {
        alert.mensagemErroComRedirectTimeout(error.response.data.message, tempoEsperaRedirect)
    }else if(error.response.data.key === 'LICITACAO_EXCLUIDA') {
        alert.mensagemErroComRedirectTimeout(error.response.data.message, tempoEsperaRedirect)
    }else{
        alert.showError(error.response.data.message)
    }
}

function tratarExceptionList(error) {
    if(_.get(error, 'response.data.errorMessages.length') === 1){
        const mensagem = _.get(error, 'response.data.errorMessages[0].message')
        alert.showError(mensagem)
    }
}

export default new ExceptionHandler()